var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddleD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "116px",
    height: "32px",
    viewBox: "0 0 116 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle Copy 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company_Q2_D",
    transform: "translate(-618.000000, -119.000000)",
    fill: "#E5744B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-4",
    transform: "translate(514.000000, 119.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.828437,0 L203.851885,0 C204.119223,1.70483254e-14 204.37543,0.107044191 204.563306,0.297233997 L219.380818,15.297234 C219.76559,15.6867446 219.76559,16.3132554 219.380818,16.702766 L204.563306,31.702766 C204.37543,31.8929558 204.119223,32 203.851885,32 L105.828437,32 C105.276152,32 104.828437,31.5522847 104.828437,31 C104.828437,30.7318243 104.936151,30.4748865 105.127392,30.2868832 L118.93489,16.7131168 C119.328734,16.3259402 119.334138,15.6927983 118.946962,15.2989548 C118.942972,15.2948966 118.938948,15.2908726 118.93489,15.2868832 L105.127392,1.7131168 C104.733548,1.32594021 104.728144,0.692798299 105.11532,0.298954763 C105.303324,0.107714194 105.560262,7.15396884e-16 105.828437,0 Z",
    id: "Rectangle-Copy-7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleD);
export default __webpack_public_path__ + "static/media/middleD.c629ed0d449feaee6f81097bc89e65b5.svg";
export { ForwardRef as ReactComponent };